import clsx from 'clsx';
import { IconButton } from '../IconButton';
import { Close } from '@material-ui/icons';
import { Tooltip } from '../Tooltip';
import { Button } from '../Button/NewButton';

interface CloseButtonProps {
  isMobile: boolean;
  onClick(): void;
  hideCloseButton: boolean;
}

export const CloseButton = ({
  isMobile,
  onClick,
  hideCloseButton,
}: CloseButtonProps) => {
  const renderButton = () => {
    if (isMobile) return <Button fullWidth>Close</Button>;

    return (
      <Tooltip title="Close">
        <IconButton>
          <Close fontSize="inherit" />
        </IconButton>
      </Tooltip>
    );
  };

  if (hideCloseButton) return null;

  return (
    <div
      className={clsx('absolute p-2 z-20', {
        'top-0 right-0 text-white': !isMobile,
        'bottom-0 left-0 w-full': isMobile,
      })}
      onClick={onClick}
    >
      {renderButton()}
    </div>
  );
};
